export const ApiResponseHeaderConstants = {
    XSRF_TOKEN: 'XSRF-TOKEN'
}